export { default } from './EditImageBlock';

export const displayName = 'Image';
